/**
 * 텍스트형 학습지/PPT 개요에 시스템이 고른 외부 그림을 그리지 않기 위한 허용 조건.
 * 사용자 업로드(Storage·data URL·편집기 blob)만 그린다.
 */

const STORAGE_HOSTS = new Set([
  'firebasestorage.googleapis.com',
  'storage.googleapis.com',
]);

const AUTO_ASSET_PATH_MARKER = 'ppt-visual-assets/';
const AUTO_IMAGE_ROLES = new Set(['visual-image', 'visual-image-frame']);

const isStorageHost = (host) => (
  STORAGE_HOSTS.has(host)
  || host.endsWith('.firebasestorage.app')
);

export function isAllowedOutlineImageSrc(src) {
  const value = String(src || '').trim();
  if (!value) return false;
  if (value.startsWith('data:image/')) return true;
  if (value.startsWith('blob:')) return true;

  let url;
  try {
    url = new URL(value);
  } catch (_error) {
    return false;
  }
  if (url.protocol !== 'https:') return false;
  const host = url.hostname.toLowerCase();
  if (!isStorageHost(host)) return false;
  const path = decodeURIComponent(`${url.pathname}${url.search}`);
  if (path.includes(AUTO_ASSET_PATH_MARKER)) return false;
  return true;
}

export function shouldRenderOutlineImage(obj) {
  if (!obj || obj.type !== 'image') return false;
  const role = obj.semantic && obj.semantic.role;
  if (AUTO_IMAGE_ROLES.has(role)) return false;
  return isAllowedOutlineImageSrc(obj.src);
}

export function shouldRenderOutlineObject(obj) {
  if (!obj) return false;
  const role = obj.semantic && obj.semantic.role;
  if (role === 'visual-image-frame') return false;
  if (obj.type === 'image') return shouldRenderOutlineImage(obj);
  return true;
}
